import { createFileRoute } from '@tanstack/react-router';
import { checkSecurityDomain } from '../../utils/auth';
import AnalyticsPageLayout from '../../components/analytics/shared/AnalyticsPageLayout';
import { getCategoryById } from '../../components/analytics/config';

export const Route = createFileRoute('/team-insights/system-performance')({
  component: RouteComponent,
  beforeLoad: checkSecurityDomain({
    routeObject: 'analytics',
  }),
});

function RouteComponent() {
  const category = getCategoryById('system-performance');

  if (!category) {
    return <div>Category not found</div>;
  }

  return (
    <AnalyticsPageLayout category={category}>
      <div className="flex h-64 items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-gray-50">
        <div className="text-center">
          <category.icon className="mx-auto mb-4 h-16 w-16 text-gray-400" />
          <h3 className="mb-2 text-lg font-medium text-gray-900">System Performance Analytics</h3>
          <p className="max-w-sm text-gray-500">
            This section will monitor system uptime, response times, hardware status, and other
            technical performance metrics.
          </p>
          <div className="mt-4">
            <span className="rounded-full bg-yellow-100 px-3 py-1 text-sm font-medium text-yellow-800">
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </AnalyticsPageLayout>
  );
}
